import styled from 'styled-components';

const ModalBody = styled.div<{ withCloseButton?: boolean }>`
  background-color: var(--surface-background);
  padding: ${props => (props.withCloseButton ? '14px 34px 34px' : '34px')};
`;

export default ModalBody;
